<div>
    <div
        class="border-b border-solid border-opacity-10 bg-[var(--color-panel)] py-2 dark:border-contrast-yellow md:hidden">
        <div class="flex flex-row items-center justify-between">
            <ion-button
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="handleBackClicked()"
                color="secondary"
                fill="clear">
                <ion-icon
                    class="mr-1 text-xl dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
                </ion-icon>
            </ion-button>
            <h1 class="text-base font-bold leading-5">
                {{ 'NOTIFICATION_SETTINGS_SIDE_TITLE' | translate }}
            </h1>
            <div class="w-12"></div>
        </div>
    </div>

    <div class="mx-auto max-w-screen-xl md:px-20 md:py-8">
        <div class="flex w-full flex-col gap-2 lg:flex-row lg:items-start lg:justify-center lg:gap-7">
            <!-- Left sidebar -->
            <div class="flex shrink-0 items-center justify-center px-2 pt-6 md:block md:w-fit md:px-0 md:pt-0">
                <h1 class="mb-6 hidden text-5xl font-normal md:block">{{ 'EDIT_SUBSCRIPTIONS_TITLE' | translate }}</h1>
                <ion-button
                    class="w-full dark:border-contrast-yellow"
                    [attr.aria-label]="'SUBSCRIBE_TO_NOTIFICATIONS_BUTTON' | translate"
                    [routerLink]="'/account/add-subscriptions' | localize"
                    size="large"
                    color="secondary">
                    <ion-label class="whitespace-normal text-sm font-bold normal-case">
                        {{ 'SUBSCRIBE_TO_NOTIFICATIONS_BUTTON' | translate }}
                    </ion-label>
                </ion-button>
            </div>

            <!-- Right content -->
            <div class="px-2 md:min-w-[700px] md:px-0">
                <div class="my-4 space-y-6 md:my-0">
                    <div
                        class="relative rounded-lg bg-[var(--color-panel)]"
                        *ngFor="let item of subscriptionItems$ | async">
                        <div class="mx-4 flex items-center justify-start pt-4">
                            <div class="flex items-center gap-2">
                                <rwidget-route-short-name
                                    *ngIf="item.type === SubscriptionType.Route"
                                    [label]="item.label"
                                    [color]="item.icon.color"
                                    [shape]="item.icon.shape || ShapeType.ROUNDED"
                                    size="md">
                                </rwidget-route-short-name>
                                <div
                                    class="flex h-8 w-8 items-center justify-center"
                                    *ngIf="item.type === SubscriptionType.Stop">
                                    <ion-icon
                                        class="text-xl dark:text-contrast-yellow"
                                        src="{{ assetsPath$ | async }}/img/explore/bus.svg">
                                    </ion-icon>
                                </div>
                                <span class="edit-subscriptions-heading text-base leading-5">
                                    {{ item.name }}
                                </span>
                            </div>

                            <ion-button
                                class="three-dot-button"
                                [attr.aria-label]="'THREE_DOT_MENU' | translate"
                                [id]="'contextual-menu-button-' + item.type + '-' + item.id"
                                fill="clear">
                                <ion-icon
                                    class="dark:filter-yellow"
                                    [attr.aria-label]="'THREE_DOT_MENU' | translate"
                                    title="{{ 'THREE_DOT_MENU' | translate }}"
                                    src="{{ assetsPath$ | async }}/img/cards/three-dot-menu.svg">
                                </ion-icon>
                            </ion-button>
                        </div>
                        <div class="mx-4 mt-4">
                            <div class="mb-4 h-px bg-gray-300 dark:bg-contrast-yellow"></div>
                            <div class="flex items-center justify-between pb-4">
                                <span class="text-base">
                                    {{ 'NOTIFICATION_SETTINGS_SEND_NOTIFICATIONS' | translate }}
                                </span>
                                <mat-slide-toggle
                                    class="toggle-slide"
                                    [checked]="item.isSubscribed"
                                    (change)="onToggleChange($event, item)">
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Desktop popover -->
    <ng-container *ngFor="let item of subscriptionItems$ | async">
        <ion-popover
            #popover
            *ngIf="!isMobile()"
            [trigger]="'contextual-menu-button-' + item.type + '-' + item.id"
            reference="trigger"
            side="bottom"
            alignment="end">
            <ng-template>
                <ion-content class="ion-padding">
                    <ion-button
                        class="text-red-500 dark:text-contrast-yellow"
                        (click)="openDeleteConfirmation(item); popover.dismiss()"
                        fill="clear">
                        <ion-label>{{ 'TEXT_DELETE' | translate }}</ion-label>
                    </ion-button>
                </ion-content>
            </ng-template>
        </ion-popover>
    </ng-container>

    <!-- Mobile modal -->
    <ng-container *ngFor="let item of subscriptionItems$ | async">
        <ion-modal
            class="mobile-contextual-menu-modal items-end"
            *ngIf="isMobile()"
            [trigger]="'contextual-menu-button-' + item.type + '-' + item.id">
            <ng-template>
                <div class="p-4">
                    <ion-button
                        class="text-red-500 dark:text-contrast-yellow"
                        (click)="openDeleteConfirmation(item)"
                        fill="clear">
                        <ion-label>{{ 'TEXT_DELETE' | translate }}</ion-label>
                    </ion-button>
                </div>
            </ng-template>
        </ion-modal>
    </ng-container>

    <!-- Delete confirmation modal -->
    <ion-modal
        class="confirmation-modal"
        #modal
        [isOpen]="isDeleteModalOpen$ | async"
        (didDismiss)="closeDeleteConfirmation()"
        data-confirmation-modal="true">
        <ng-template>
            <div class="rounded-lg bg-white p-6">
                <div class="relative mb-4 flex items-center justify-center">
                    <h2 class="text-center text-lg font-semibold">
                        {{
                            ((itemToDelete$ | async)?.type === 'route'
                                ? 'ROUTE_NOTIFICATIONS_TITLE'
                                : 'STOP_NOTIFICATIONS_TITLE'
                            ) | translate
                        }}
                    </h2>
                    <ion-button
                        class="modal-close-button absolute right-0"
                        (click)="openDeleteConfirmation(item); popover.dismiss()"
                        fill="clear">
                        <ion-icon name="close"></ion-icon>
                    </ion-button>
                </div>

                <div class="mb-4 h-px bg-gray-300 dark:bg-contrast-yellow"></div>

                <div class="mb-4 flex items-center gap-2">
                    <rwidget-route-short-name
                        *ngIf="(itemToDelete$ | async)?.type === 'route'"
                        [label]="(itemToDelete$ | async)?.label"
                        [color]="(itemToDelete$ | async)?.icon?.color"
                        [shape]="(itemToDelete$ | async)?.icon?.shape || ShapeType.ROUNDED"
                        size="md">
                    </rwidget-route-short-name>
                    <div
                        class="flex h-8 w-8 items-center justify-center"
                        *ngIf="(itemToDelete$ | async)?.type === 'stop'">
                        <ion-icon class="text-xl" src="{{ assetsPath$ | async }}/img/explore/bus.svg"> </ion-icon>
                    </div>
                    <span class="edit-subscriptions-heading text-base leading-5">
                        {{ (itemToDelete$ | async)?.name }}
                    </span>
                </div>

                <div class="mb-4 h-px bg-gray-300 dark:bg-contrast-yellow"></div>

                <ion-button
                    class="edit-subscriptions-heading text-base leading-5 text-red-500 dark:text-contrast-yellow"
                    (click)="confirmDelete()"
                    fill="clear"
                    expand="full">
                    <ion-label>
                        {{ 'TEXT_DELETE' | translate }}
                    </ion-label>
                </ion-button>
            </div>
        </ng-template>
    </ion-modal>
</div>
